import { Responsive } from '@cian/ui-kit';
import { FC } from 'react';

import { MotivationDesktop } from './MotivationDesktop';
import { MotivationMobile } from './MotivationMobile';
import { TPlatform } from '../../types/platform';
import * as style from './style.css';

interface IMotivationProps {
  platform: TPlatform;
  isBottom?: boolean;
  onClick: (buttonName: string) => void;
}

export const Motivation: FC<IMotivationProps> = ({ isBottom, platform, onClick }) => {
  return (
    <>
      <Responsive desktop tablet>
        {isBottom ? (
          <div className={style['container']}>
            <MotivationDesktop isBottom />
          </div>
        ) : (
          <MotivationDesktop />
        )}
      </Responsive>
      <Responsive phone>
        <MotivationMobile platform={platform} isBottom={isBottom} onClick={onClick} />
      </Responsive>
    </>
  );
};
